export const GENERIC_CONFIGS = {
  panelClass: 'no-radius-dialog',
  maxWidth: '2160px',
  maxHeight: '1080px',
};

export const RESPONSE_MODAL_CONFIGS = {
  width: '42vw',
  ...GENERIC_CONFIGS,
};

export const ACTIVE_SESSIONS_MODAL_CONFIGS = {
  width: '56vw',
  ...GENERIC_CONFIGS,
};

export const CONFIRMATION_MODAL_CONFIGS = {
  width: '41vw',
  ...GENERIC_CONFIGS,
};

export const CONTENT_VIEW_MODAL_CONFIGS = {
  ...GENERIC_CONFIGS,
  maxHeight: '99vh',
  maxWidth: '75vw',
};

export const SLIDE_MODAL_CONFIGS = {
  ...GENERIC_CONFIGS,
  maxHeight: '81vh',
  maxWidth: '75vw',
};
